import React from "react";
import { useNavigate } from "react-router-dom";
import { MdLocationOn, MdDirectionsCar, MdPayment, MdCheckCircle } from "react-icons/md";

const ReservationJourney = ({ currentStep = 2 }) => {
  const navigate = useNavigate();

  const steps = [
    { id: 1, title: "SELECT YOUR LOCATION", shortTitle: "LOCATION", icon: MdLocationOn, clickable: true },
    { id: 2, title: "SELECT YOUR VEHICLE", shortTitle: "VEHICLE", icon: MdDirectionsCar, clickable: true },
    { id: 3, title: "COMPLETE YOUR RESERVATION", shortTitle: "RESERVE", icon: MdPayment, clickable: false },
  ];

  // const handleStepClick = (step) => {
  //   if (!step.clickable || step.id >= currentStep) return;
  //   const originalSearchURL = localStorage.getItem("originalSearchURL");
  //   if (originalSearchURL) {
  //     window.location.href = originalSearchURL;
  //   } else {
  //     navigate("/");
  //   }
  // };

  const handleStepClick = (step) => {
    if (!step.clickable || step.id >= currentStep) return;

    // 2. Logic for Step 1 (LOCATION) -> Always go to Home
    if (step.id === 1) {
      navigate("/");
      return;
    }

    // 3. Logic for Step 2 (VEHICLE) -> Go to the Results page
    const originalSearchURL = localStorage.getItem("originalSearchURL");
    if (originalSearchURL) {
      window.location.href = originalSearchURL;
    } else {
      navigate("/");
    }
  };
  return (
    <div className="w-full py-4 mt-12">
      <div className="max-w-7xl mx-auto px-2 sm:px-4">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isActive = step.id === currentStep;
            const isCompleted = step.id < currentStep;

            return (
              <React.Fragment key={step.id}>
                {/* Step Item */}
                <div 
                  className={`flex items-center gap-1 md:gap-2 transition-all ${
                    isCompleted || isActive ? "cursor-pointer" : "opacity-50"
                  }`}
                  onClick={() => handleStepClick(step)}
                >
                  <div className="flex-shrink-0 relative flex items-center justify-center">
                    {isCompleted ? (
                      <MdCheckCircle className="text-primary w-6 h-6 md:w-8 md:h-8" />
                    ) : (
                      <div className={`w-6 h-6 md:w-8 md:h-8 rounded-full border-2 flex items-center justify-center transition-colors ${
                        isActive ? "border-primary bg-primary text-white" : "border-slate-300 text-slate-400"
                      }`}>
                        <Icon className="text-[10px] md:text-[14px]" />
                      </div>
                    )}
                  </div>
                  
                  <div className="flex flex-col">
                    {/* LONG TITLE: Shown only on Large screens (lg and up) */}
                    <span className={`hidden lg:block text-[10px] font-bold tracking-[0.1em] uppercase ${
                      isActive ? "text-primary" : "text-slate-600"
                    }`}>
                      {step.title}
                    </span>

                    {/* SHORT TITLE: Shown on mobile and tablet, hidden on Large */}
                    <span className={`block lg:hidden text-[9px] md:text-[10px] font-bold tracking-[0.05em] uppercase ${
                      isActive ? "text-primary" : "text-slate-600"
                    }`}>
                      {step.shortTitle}
                    </span>
                  </div>
                </div>

                {/* Connector Line */}
                {index !== steps.length - 1 && (
                  <div className="flex-1 mx-2 md:mx-4 h-[2px] md:h-[3px] bg-slate-200 relative overflow-hidden rounded-full">
                    <div 
                      className="absolute h-full bg-primary transition-all duration-700" 
                      style={{ width: isCompleted ? "100%" : "0%" }}
                    />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReservationJourney;